'use strict';

(function () {
  var _controller = 'preReservation.controller';
  angular.module('pentaApp').controller(_controller, controller);
  controller.$inject = ['$scope', 'router.resource', 'preReservation.resource'];
  function controller($scope, routerResource, preReservationResource) {
    //// Methods
    $scope.send = send;


    //// VARS
    $scope.item = {};
    $scope.item.router = appNavigator.topPage.data && appNavigator.topPage.data.router;

    // WATCHERS
   
    // INIT


    ///////////////////////////

    function send(){
      $scope.item._controller = _controller;
      preReservationResource.save($scope.item, function(){
        ons.notification.toast(i18next.t('Solicitud enviada con éxito. Un encargado se comunicará a la brevedad para coordinar los detalles de tu reserva'), { timeout: 5000 })
        appNavigator.replacePage('reservations/reservations.jade');

      })
    }



    ///// FIN FUNCIONES CONTROLLER
  }
})();

